/**
 * Uploads an inline note image to the backend (sharp → WebP → public
 * lead-note-media bucket) and returns its hosted URL — the only img src the
 * note sanitizers (client + server) accept. Returns null on failure so the
 * editor can simply skip the insert.
 */

import { getApiUrl } from "@/app/_module/services/config";
import { endpoint } from "@/app/_module/services/endpoints";
import supabaseAuthService from "@/app/_module/services/supabaseAuthService";
import AgencyTokenManager from "@/app/_module/services/agencyTokenManager";

export async function uploadNoteImage(leadId: string, file: File): Promise<string | null> {
  try {
    let token = await supabaseAuthService.getAccessToken();
    if (!token) {
      const refreshed = await supabaseAuthService.refreshSession();
      token = refreshed?.access_token || null;
    }
    if (!token) return null;

    const form = new FormData();
    form.append("file", file);

    const headers: Record<string, string> = { Authorization: `Bearer ${token}` };
    const agencyId = AgencyTokenManager.getCurrentAgencyId();
    if (agencyId) headers["x-agency-id"] = agencyId;

    const res = await fetch(getApiUrl(endpoint.leads.uploadLeadNoteImage(leadId)), {
      method: "POST",
      headers,
      body: form,
    });
    if (!res.ok) return null;
    const json = await res.json();
    return json?.data?.url || null;
  } catch {
    return null;
  }
}
